import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "symbol",
  "use": "symbol-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"symbol\"><path fill=\"currentColor\" d=\"M12 0C7.802 0 4 3.403 4 7.602c0 6.243 6.377 6.903 8 16.398 1.623-9.495 8-10.155 8-16.398C20 3.403 16.199 0 12 0m0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol